const hostname = window.location.hostname;

const ENVIRONMENTS = {
  PROD: "prod",
  QA: "qa",
  STAGING: "staging",
  DEV: "dev",
  LOCAL: "local",
};

const getEnvironment = (host) => {
  if (host === "localhost" || host === "127.0.0.1") {
    return ENVIRONMENTS.LOCAL;
  }

  if (host.includes("qa.azurewebsites.net")) {
    return ENVIRONMENTS.QA;
  }

  if (host.includes("staging.azurewebsites.net")) {
    return ENVIRONMENTS.STAGING;
  }

  if (host.includes("dev.azurewebsites.net")) {
    return ENVIRONMENTS.DEV;
  }

  return ENVIRONMENTS.PROD;
};

export const ENV = getEnvironment(hostname);
export const IS_PROD = ENV === ENVIRONMENTS.PROD;

const API_URLS = {
  [ENVIRONMENTS.PROD]:
    "https://invivyd-api-fyexgcdecehyb4ef.centralus-01.azurewebsites.net/api",

  [ENVIRONMENTS.QA]:
    "https://invivyd-api-staging-ftfzheezfgf9cvad.centralus-01.azurewebsites.net/api",

  [ENVIRONMENTS.STAGING]:
    "https://invivyd-api-staging-ftfzheezfgf9cvad.centralus-01.azurewebsites.net/api",

  [ENVIRONMENTS.DEV]:
    "https://invivyd-api-dev-fvbqaad2hzapdyhw.centralus-01.azurewebsites.net/api",

  [ENVIRONMENTS.LOCAL]:
    "https://invivyd-api-dev-fvbqaad2hzapdyhw.centralus-01.azurewebsites.net/api",
};

const API_BASE_URL = API_URLS[ENV];

export const HCP_API_URL = `${API_BASE_URL}/connectwithushcp`;
export const INFUSION_LOCATOR = `${API_BASE_URL}/requestfacility`;
export const DTC_API_URL = `${API_BASE_URL}/hub`;

export const API_KEY = "IuJZIFpR7LGWvY8HuJm28QepaDBex2Na";
export const DTC_EXTERNAL_KEY = IS_PROD ? "9F47F8EC-922E-4551-9DE4-4B1D69AAB94C" : "1ADE5856-16F6-4F1A-B714-94F0CCD2A84B";

export async function resetDropdowns(form) {
  document.querySelectorAll(".custom-select").forEach((select) => {
    select.querySelector(".selected-value").textContent = "Choose one";
    select.querySelector('input[type="hidden"]').value = "";

    select.querySelectorAll(".select-options li")
      .forEach((option) => option.classList.remove("selected"));

    select.classList.remove("open");
  });
}

export async function showThankYouModal() {
  const formModal = document.getElementById("myModal");
  const thankyouModal = document.getElementById("thankyouModal");

  if (formModal) {
    formModal.close();
  }

  if (thankyouModal) {
    thankyouModal.showModal();
  }
}

(function () {
  const STORAGE_KEY = "referralSource";

  const existing = localStorage.getItem(STORAGE_KEY);
  if (existing && existing !== "direct") {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get("utm_source");
  const referrer = document.referrer;

  let referralSource = "direct";

  if (utmSource) {
    referralSource = utmSource;
  } else if (referrer) {
    try {
      const referrerHostname = new URL(referrer).hostname;
      if (referrerHostname !== window.location.hostname) {
        referralSource = referrerHostname;
      }
    } catch (e) {
      referralSource = "unknown";
    }
  }

  localStorage.setItem(STORAGE_KEY, referralSource);
})();

export function getReferralSource() {
  const referralSource = localStorage.getItem("referralSource")
  if (!referralSource || referralSource == 'direct') { return "" } else { return referralSource }

}

document.querySelectorAll('#updates-form, #contact-form, #updates-form-hcp').forEach((form) => {
  form.querySelectorAll('input, select, textarea, button').forEach((element) => {
    if (!element.disabled && Number(element.getAttribute('tabindex')) > 0) {
      element.removeAttribute('tabindex');
    }
  });
});
// document.querySelectorAll('input[type="tel"]').forEach((input) => {
//   input.addEventListener('input', () => {
//     input.value = input.value.replace(/[^\d+().\s-]/g, '').slice(0, 20);
//   });
// });